import useFeatureManager from "hooks/featureManager";
import { useEffect, useState } from "react";
import { FeatureFlag } from "utils/feature-management/amplitude";

/** Amplitude Experiment flag — enable the booking-flow UI redesign incrementally. */
export const BOOKING_FLOW_REDESIGN_FLAG = "booking-flow-redesign";

export default function useBookingFlowRedesign(): boolean {
    const [featureManager] = useFeatureManager();
    const [, setFlagRevision] = useState(0);

    useEffect(() => {
        if (!featureManager?.subscribe) {
            return;
        }

        return featureManager.subscribe(() => {
            setFlagRevision((revision) => revision + 1);
        });
    }, [featureManager]);

    return (
        featureManager?.isFeatureFlagEnabled(
            BOOKING_FLOW_REDESIGN_FLAG,
            FeatureFlag.On
        ) ?? false
    );
}
